/**
 * The system roles. They are fixed in code, not master data (mirrors the backend's `RoleCodes`): a user's `role.key` and `role.value`
 * are one of these codes. Module roles (DOCTOR-VIEW, PATIENT-ADMIN, ...) are different: they stay in the master data (USER-ROLE with a
 * subContext) and carry the permissions.
 */
export const ROLE_CODES = {
  SysAdmin: 'SYSADMIN',
  OrgAdmin: 'ORG-ADMIN',
  OrgDoctor: 'ORG-DOCTOR',
  OrgStaff: 'ORG-STAFF',
  GenUser: 'GEN-USER',
} as const;

/** The roles an organization can give to its users (only the application admin holds SYSADMIN). */
export const ASSIGNABLE_ROLE_CODES: string[] = [ROLE_CODES.OrgAdmin, ROLE_CODES.OrgDoctor, ROLE_CODES.OrgStaff, ROLE_CODES.GenUser];
